export default __webpack_public_path__ + "static/media/angry-monster.9a74c81b.png";